<template>
  <div class="home-container">
    <div class="home-content">
  <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                label-width="100px"
                style="width: 80%"
              >
                 <el-select
                  clearable filterable
                  v-model="searchForm.ridgepoleId"
                  placeholder="请选择楼栋"
                   @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="单元名称"
                prop="ridgepoleId"
                label-width="100px"
                style="width: 80%"
              >
                 <el-select
                  clearable filterable
                  v-model="searchForm.unitId"
                  placeholder="请选择单元"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>            
            <el-col :span="6">
              <el-form-item
                label="楼层名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入楼层名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px;display: flex;">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        
        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          @click="download"
          >下载导入模板</el-button>     
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action=""
          :http-request="handleUpload"
          :show-file-list="false"
        >
          <el-button
            size="small"
            type="primary"
            style="margin-left: 10px"
            icon="el-icon-upload2"
          >
            批量导入
          </el-button>
        </el-upload>
        <!-- <el-button size='small' @click="" type="success" style="width:90px">搜索</el-button> -->
        <!-- <el-button size='small' @click="" type="danger" style="width:90px">重置</el-button> -->
      </div>

      <el-table
        border
        :data="
          tableData
        "
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="id" label="id" align="center">
        </el-table-column>
        <el-table-column prop="weight" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="ridgepoleName" label="楼栋信息" align="center">
        </el-table-column>
        <el-table-column prop="unitName" label="单元信息" align="center">
        </el-table-column>
        <el-table-column prop="name" label="楼层信息" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <!-- <el-button
              type="text"
              size="small"
              @click="orderGenerate(scope.row)"
              >生成账单</el-button
            >             -->
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="20%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          
          label-position="center"
        >
        <el-row>
            <el-col :span="24">
              <el-form-item label="排序" prop="weight">
                 <el-input-number v-model="addData.weight"  :min="1"  label="请输入序号"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        <el-row>
            <el-col :span="24">
              <el-form-item label="楼栋信息" prop="ridgepoleId">
                 <el-select
                  clearable filterable
                  v-model="addData.ridgepoleId"
                  placeholder="请选择"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addData.ridgepoleId"> 
          <el-col :span="24">
              <el-form-item label="单元信息" prop="unitId">
                 <el-select
                  clearable filterable
                  v-model="addData.unitId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="楼层信息" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入楼层信息"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 批量生成账单 -->
      <el-dialog title="批量生成账单" :visible.sync="billFlags" width="50%">
        <el-form
          ref="billForm"
          :model="fromData"
          label-width="90px"
          :rules="fromDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="缴费类型" prop="billCategoryId">
                <el-select clearable filterable v-model="fromData.billCategoryId" placeholder="请选择类型" @change="getBillId">
                  <el-option
                    v-for="(item, ind) in typeData"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="缴费模板" prop="billTemplateId" label-width="120px">
                <el-select clearable filterable v-model="fromData.billTemplateId" placeholder="请选择模板">
                  <el-option
                    v-for="(item, ind) in templateData"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>            
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始日期" prop="time">
                  <el-date-picker
                    v-model="fromData.time"
                    type="date"
                    placeholder="选择开始日期">
                  </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账单期数(月)" prop="month" label-width="120px">
               <el-input-number v-model="fromData.month" :min="1" :max="12" label="请输入账单缴费期数"></el-input-number>
              </el-form-item>
            </el-col>            
          </el-row>    
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="请输入备注"
                    v-model="fromData.remark">
                  </el-input>
              </el-form-item>
            </el-col>     
            <el-col :span="12" v-if="isFixedAmount == -1">
              <el-form-item label="单位数量(度/吨)"  label-width="120px">
                <el-input-number v-model="fromData.unitCount" :min="1" label="请输入账单缴费数量"></el-input-number>
              </el-form-item>
            </el-col>    
          </el-row>                   
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="billFlags = false">取 消</el-button>
          <el-button type="primary" @click="billSubmit"
            >确 定</el-button
          >
        </span>
      </el-dialog>        
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg"
import unit from "./unit.vue"
export default {
  components:{
    unit
  },
  data() {
    return {
      searchForm: {
        name: "",
        ridgepoleId:'',
        unitId:''
      },   
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag:true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "", 
        name: "", 
        ridgepoleId:'',
        weight:'',
        unitId:''
      },
      addDataRules: {
        ridgepoleId: [
          { required: true, message: "请选择楼栋", trigger: "blur" },
        ],
        unitId: [
          { required: true, message: "请选择单元", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入楼层名称", trigger: "blur" },
        ],
      },
      fromData:{
        billCategoryId:'',
        billTemplateId:'',
        month:'',
        remark:'',
        time:'',
        unitCount:'',
      },
      fromDataRules:{
        billCategoryId: [
          { required: true, message: "请选择缴费类型", trigger: "blur" },
        ],
        billTemplateId: [
          { required: true, message: "请选择缴费模板", trigger: "blur" },
        ],
        month: [
          { required: true, message: "请输入缴费月数", trigger: "blur" },
        ],     
        time: [
          { required: true, message: "请输入开始缴费日期", trigger: "blur" },
        ],     
      },       
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      ridgepoleList:[],
      unitList:[],
      multipleSelection:[],
      templateData:[],
      billFlags:false,
      isFixedAmount:'',
      typeData:[],      
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    handleUpload({ file }) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$Apis.getExportCode().then(res=>{
          if(res.code == 200){
            var formData = new FormData();
            formData.append("file", file);
            formData.append("uCode",res.data)
            formData.append(
              "villageId",
              JSON.parse(localStorage.getItem("park_data")).id
            );
            this.$Apis.importBatchHome(formData).then((res) => {
              loading.close();
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.onLoad();
              } else {
                this.$message.warning(res.msg);
              }
             
            });
          }
        })
        
      } catch (error) {
        loading.close();
      }
    },
    download(){
      this.$Apis.getExportCode().then(res=>{
        if(res.code == 200){
          window.location.href = process.env.VUE_APP_UPLOAD_REAL_PATH + '/export/batchHomeTemplate?uCode=' + res.data
        }
      })
      
    },
    getBillId(e){
      let id = this.typeData.filter(res=> e == res.id)
      if(id.length > 0){
        this.isFixedAmount = id[0].isFixedAmount
      }
    },    
    // 生成提交
    billSubmit(){
         this.$refs["billForm"].validate((valid)=>{
          if(valid){
            let data = {
              time:reg.filterTime(this.fromData.time),
              billCategoryId:this.fromData.billCategoryId,
              billTemplateId:this.fromData.billTemplateId,
              month:this.fromData.month,
              floorIds:this.multipleSelection.join(','),
              unitCount:this.fromData.unitCount || ''
            }

            this.$Apis.billBatchCreateBill(data).then(res=>{
              this.billFlags = false
              if(res.code == 200){
                this.$message.success(res.msg)
              }else{
                this.$message.warning(res.msg)
              }
            })
          }
         })
    },    
    // 生成账单
    orderGenerate(row) {
      this.multipleSelection = []
      this.multipleSelection.push(row.id)
      this.billFlags = true
    },    
   // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },      
    // 选择楼栋
    ridgepoleSelect(e,row){
      this.$Apis.unitAllList({ridgepoleId:e}).then(res=>{
        if(res.code == 200){
          this.unitList = res.data
          // this.addData.unitId = ''
          // this.addData.name = ''
          // this.searchForm.unitId = ''
          // this.searchForm.name = ''  
          if(row == 'updata'){
           this.isAddModal = true;
          }else{
            this.addData.unitId = ''
            this.addData.name = ''
          }
        }
      })
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {  
      this.ridgepoleSelect(row.ridgepoleId,'updata')
      this.addData = JSON.parse(JSON.stringify(row))
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.floorDel({ id }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id:this.addData.id || "",
            ridgepoleId:this.addData.ridgepoleId,
            unitId:this.addData.unitId,
            weight:this.addData.weight,
            name: this.addData.name,
          };
          this.$Apis.floorAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ridgepoleId:this.searchForm.ridgepoleId,
        unitId:this.searchForm.unitId,
        name:this.searchForm.name,
      };
      this.$Apis.houseAllList().then(res=>{
        if(res.code == 200){
          this.ridgepoleList = res.data
        }
      })
       this.$Apis.billCategoryAllList(page).then((res) => {
          if(res.code == 200){
              this.typeData = res.data
          }
       })  
      //  this.$Apis.billTemplateAllList(page).then((res) => {
      //     if(res.code == 200){
      //         this.templateData = res.data
      //     }
      //  })        
      this.$Apis.floorList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>